import type { SelfDriveSelectorResponse } from '@/scopes/prices/domain/transports/types'
import type { SelfDriveApiRawResponse } from './types'
import { mapPriceBreakdown } from '../mapPriceBreakdown'
import { mapTripSummary } from '../mapTripSummary'
import { TransportType } from '../urlBuilder/transportSelectorUrlBuilder'

export interface SelfDriveSelectorResponseMapper {
  map: (selfDriveResponse: SelfDriveApiRawResponse) => SelfDriveSelectorResponse
}

export function createSelfDriveSelectorResponseMapper(): SelfDriveSelectorResponseMapper {
  return {
    map: (selfDriveResponse: SelfDriveApiRawResponse): SelfDriveSelectorResponse => {
      const tripSummary = selfDriveResponse.tripSummary?.map(mapTripSummary)
      const priceBreakdown = mapPriceBreakdown(selfDriveResponse.priceBreakdown, selfDriveResponse.averagePriceRaw)

      return {
        transportType: TransportType.SelfDrive,
        tripSummary,
        priceBreakdown,
        contentUsps: selfDriveResponse.contentUsps,
        paymentMethod: selfDriveResponse.paymentMethod,
      }
    },
  }
}
